import { render, staticRenderFns } from "./TransferDetail.vue?vue&type=template&id=c14ee2aa&scoped=true"
import script from "./TransferDetail.vue?vue&type=script&lang=js"
export * from "./TransferDetail.vue?vue&type=script&lang=js"
import style0 from "./TransferDetail.vue?vue&type=style&index=0&id=c14ee2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14ee2aa",
  null
  
)

export default component.exports